// @ts-nocheck
const wait = (time: number | undefined) =>
  new Promise((res) => setTimeout(res, time));

export default wait;
